import React from 'react';
import Sidebar from '../components/sidebar';
import { Card, Typography, Button } from 'antd';
import { VideoCameraOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import './CampanaVideo.css';

const { Title, Text } = Typography;

const CampanaVideo = () => {
  const navigate = useNavigate();

  const handleVolver = () => {
    navigate('/seleccion-tipo-campana');
  };

  return (
    <div>
      <Sidebar>
        <div className="campana-video-container">
          <div className="text-center mb-4">
            <div className="campana-video-icon">
              <VideoCameraOutlined />
            </div>
            <Title level={3} className="campana-video-title">
              🎬 Campana de Video
            </Title>
            <Text className="campana-video-subtitle">
              Esta funcionalidad estará disponible próximamente
            </Text>
          </div>

          <Card className="coming-soon-card">
            <div className="text-center">
              <Title level={4}>🚧 En Desarrollo</Title>
              <Text className="coming-soon-text">
                Estamos trabajando en las herramientas para crear campañas de video. 
                Esta funcionalidad incluirá:
              </Text>
              
              <div className="features-list">
                <div className="feature-item">
                  <Text>🎥 Editor de video integrado</Text>
                </div>
                <div className="feature-item">
                  <Text>📊 Análisis de rendimiento de videos</Text>
                </div>
                <div className="feature-item">
                  <Text>🎯 Segmentación de audiencia por video</Text>
                </div>
                <div className="feature-item">
                  <Text>📱 Optimización para diferentes plataformas</Text>
                </div>
              </div>

              <div className="mt-4">
                <Button
                  type="primary"
                  icon={<ArrowLeftOutlined />}
                  onClick={handleVolver}
                  style={{
                    backgroundColor: '#1890ff',
                    borderColor: '#1890ff',
                    borderRadius: '8px',
                    height: '40px',
                    fontSize: '14px',
                    fontWeight: 'bold'
                  }}
                >
                  Volver a Selección
                </Button>
              </div>
            </div>
          </Card>
        </div>
      </Sidebar>
    </div>
  );
};

export default CampanaVideo;
